<p-tabs [value]="activeTabIndex" (valueChange)="onTabChange($event)">
  <p-tablist>
    <p-tab value="0">{{ 'contacts.tabs.contacts' | transloco }}</p-tab>
    <p-tab value="1">{{ 'contacts.tabs.authorities' | transloco }}</p-tab>
    <p-tab value="2">{{ 'contacts.tabs.veterinarians' | transloco }}</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      @if (activeTabIndex === '0') {
        <app-contact-management></app-contact-management>
      }
    </p-tabpanel>
    <p-tabpanel value="1">
      @if (activeTabIndex === '1') {
        <app-competent-authorities-management></app-competent-authorities-management>
      }
    </p-tabpanel>
    <p-tabpanel value="2">
      @if (activeTabIndex === '2') {
        <app-contact-management [onlyVeterinarians]="true"></app-contact-management>
      }
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
